/* eslint-disable max-len */
import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'

class OfferGCPRService {
  constructor() {
    this.resource = API_RESOURCE.OFFER
  }

  submitGCMaterialPR = async ({ offerId, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}/submit`,
      data
    )
    return response.data
  }
  updateGCMaterialPR = async ({ offerId, submissionIndex, ...data }) => {
    const response = await axios.patch(`${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}`, data)
    return response.data
  }
  approveGCMaterialPR = async ({ offerId, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}/approve`,
      data
    )
    return response.data
  }
  rejectGCMaterialPR = async ({ offerId, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}/reject`,
      data
    )
    return response.data
  }
  resubmitGCMaterialPR = async ({ offerId, submissionIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}/resubmit`,
      data
    )
    return response.data
  }
  archiveGCMaterialPR = async ({ offerId, submissionIndex }) => {
    const response = await axios.put(`${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}/archive`)
    return response.data
  }

  inviteGCPRUser = async ({ offerId, submissionIndex, approverIndex, ...data }) => {
    const response = await axios.post(
      `${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}/approver/${approverIndex}/invitee`,
      data
    )
    return response.data
  }

  replyGCPRInvitation = async ({ offerId, submissionIndex, approverIndex, inviteeIndex, ...data }) => {
    const response = await axios.put(
      `${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}/approval/${approverIndex}/invitee/${inviteeIndex}/reply`,
      data
    )
    return response.data
  }

  deleteGCPRInvitedUser = async ({ offerId, submissionIndex, approverIndex, inviteeIndex }) => {
    const response = await axios.delete(
      `${this.resource}/${offerId}/GCMaterialSubmissions/${submissionIndex}/approval/${approverIndex}/invitee/${inviteeIndex}`
    )
    return response.data
  }
  batchApproveGCPR = async (data) => {
    const response = await axios.put(`${this.resource}/GCPR/batchApprove`, data)
    return response.data
  }
}
export default OfferGCPRService
